import React from 'react'
import { Routes,Route } from 'react-router-dom'
import Home from '../pages/home/Home'
import About from '../pages/About'
import Store from '../pages/Store'
import Contact from '../pages/Contact'
import Login from '../pages/Login'
import Signup from '../pages/Signup'
import Cart from '../pages/Cart'
import Checkout from '../pages/Checkout'
import Profile from '../pages/Profile'
import Wishlist from '../pages/Wishlist'
import FirestoreDemo from '../components/FirestoreDemo'

const Routers = () => {
  return (
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/store" element={<Store />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/cart" element={<Cart />} />
          <Route path="/checkout" element={<Checkout />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/wishlist" element={<Wishlist />} />
          <Route path="/firestore-demo" element={<FirestoreDemo />} />
        </Routes>
  )
}

export default Routers